import React from "react";
import AboutUsCard from "./aboutuscard";
import { useState, useEffect, useRef } from "react";


const AboutCompany = ({ content }) => {

  const [isVisible, setIsVisible] = useState(false);
  const componentRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (componentRef.current) {
        const top = componentRef.current.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (top < windowHeight) {
          setIsVisible(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on mount in case the component is already in the viewport

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={` py-20 bg-white transition-opacity duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`} ref={componentRef}>
      <div className="lg:text-6xl md:text-3xl text-xl lg:px-[100px] md:px-[60px] px-[30px] text-black font-bold mt-10 mb-20">About Us</div>
      <div className="grid gap-10 px-10">
        {content.data.map((item, index) => (
          <AboutUsCard key={index} data={item} />
        ))}
      </div>
    </div>
  );
};

export default AboutCompany;
